import { createContext } from 'react'

import { registerSharedDependency } from 'core-components/helpers/MFHelper'
import { SIZE_SELECTOR_DATA } from 'core-components/sitebuilder/layout/context/constants/sizeSelector'
import { TAppIframeWidgetData } from 'core-components/sitebuilder/models/IWidgetData'
import { TAppWidget } from 'core-components/sitebuilder/models/IWidgetSelector'

interface ISelectorData {
  sizeSelector?: { id: string; label: string }[]
}

interface ISettingsLayout {
  selectorData?: ISelectorData
}

export interface ISiteBuilderContext {
  AppWidgets: TAppWidget
  getAppIframeWidgets: TAppIframeWidgetData | undefined
  settingsLayout?: ISettingsLayout
}

const SiteBuilderContextLocal = createContext<ISiteBuilderContext>({
  AppWidgets: () => <div>Empty SiteBuilderContext for AppWidgets</div>,
  getAppIframeWidgets: undefined,
  settingsLayout: {
    selectorData: {
      sizeSelector: SIZE_SELECTOR_DATA,
    },
  },
})

export const SiteBuilderContext = registerSharedDependency<typeof SiteBuilderContextLocal>(
  'SiteBuilderContext',
  () => SiteBuilderContextLocal
)
